import { initializeApp } from 'firebase/app';
import { ActionCodeSettings, getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_GCP_API_KEY,
  appId: process.env.REACT_APP_GCP_APPID,
  authDomain: process.env.REACT_APP_GCP_AUTH_DOMAIN,
  messagingSenderId: process.env.REACT_APP_GCP_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_GCP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_GCP_STORAGE_BUCKET,
};

const app = initializeApp(firebaseConfig);
const dbId = process.env.REACT_APP_GCP_FIRESTORE_DB_ID ?? '(default)';
export const auth = getAuth(app);
export const db = getFirestore(app, dbId);
export const functions = getFunctions(app);
export const storage = getStorage();

export const redirectUrl = (email: string): string => {
  // Base64URLエンコードでメールアドレスの特殊文字（+, @等）によるFirebaseリダイレクト問題を回避
  const encoded = btoa(email).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const params = `?e=${encoded}`;
  return `${window.location.protocol}//${window.location.host}/staff/register` + `${params}`;
};

export const actionCodeSettings = (email: string): ActionCodeSettings => {
  const url: string = redirectUrl(email);
  return {
    handleCodeInApp: true,
    url,
  };
};

export const passwordSendSettings = (): ActionCodeSettings => ({
  handleCodeInApp: true,
  url: `${window.location.protocol}//${window.location.host}/auth/password_change`,
});
